import type { ReactNode } from 'react';

import { SuspenseFallback } from './suspense-fallback';

export interface PageLoadingStateProps {
  message?: string;
  className?: string;
  children?: ReactNode;
}

export default function PageLoadingState({
  message = 'Loading…',
  className,
  children,
}: PageLoadingStateProps) {
  if (children) return <>{children}</>;

  return <SuspenseFallback variant="centered" message={message} className={className} />;
}
